var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex flex-row gap-1" },
    [
      _c(
        "a",
        {
          staticClass: "btn btn-primary btn-sm w-100",
          attrs: {
            href: _vm.link,
            rel: "noopener noreferrer",
            target: "_blank"
          }
        },
        [
          _vm._t("default"),
          _vm._v(
            " " +
              _vm._s(!this.$slots.default ? _vm.title || _vm.link : "") +
              " "
          )
        ],
        2
      ),
      _c(
        "vx-tooltip",
        { attrs: { text: "Copiar enlace", placement: "top" } },
        [
          _c(
            "b-button",
            {
              attrs: { size: "sm", variant: "primary" },
              on: { click: _vm.copyLink }
            },
            [
              _c("feather-icon", {
                staticClass: "align-text-top",
                attrs: { icon: "ClipboardIcon", size: "16" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }